// extracted by mini-css-extract-plugin
export default {"button":"UploadFile_button__Y-7S-","input":"UploadFile_input__II6g+"};